import { useState } from 'react'
import { useSession } from '../auth/SessionContext.js'
import { leaveImpersonation } from './leaveImpersonation.js'

/**
 * Persistent, non-dismissible banner shown on every authenticated view while an
 * impersonation is active (spec FR-003/004/005/006). Renders nothing for normal
 * sessions (FR-009). Visual: the established yellow warning-bar — exact match
 * pending the platform's canonical banner (FR-005).
 */
export function ImpersonationBanner() {
  const { session } = useSession()
  const [leaving, setLeaving] = useState(false)
  const impersonator = session?.impersonator
  if (!session || !impersonator) return null

  const displayName = session.user.name ?? session.user.email ?? 'this user'

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-2 bg-warning-bg px-4 py-2 text-sm text-body"
    >
      <span>
        You are currently logged in as <strong>{displayName}</strong>.
      </span>
      <button
        type="button"
        disabled={leaving}
        onClick={() => {
          setLeaving(true)
          void leaveImpersonation({
            impersonatorId: impersonator.id,
            impersonatedId: session.user.id,
          })
        }}
        className="font-semibold underline disabled:opacity-60"
      >
        Return to your account
      </button>
    </div>
  )
}
